import { render } from "./Totals.vue?vue&type=template&id=9cbf34ae"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__